export const DEFAULT_FORM = Object.freeze({
  label: '',
  description: '',
  addressQuery: '',
});

export const DEFAULT_GEOFENCE_RADIUS_METERS = 100;
export const GEOCODE_RESULTS_LIMIT = 5;
export const ADDRESS_INPUT_PLACEHOLDER = 'Ex.: Av. Paulista, 1000 - São Paulo, SP';
export const LOCATION_DESCRIPTION_PLACEHOLDER = 'Aproveite que está por perto e venha conferir as melhores ofertas!';
